import React, { useState, useEffect, useCallback } from "react";
import LeftPanel from "../LeftPanel/LeftPanel";
import config from "../../config";
import { ToastContainer, toast } from "react-toastify";
import {
    useSearchParams,
    Link,
    useNavigate,
    useLocation,
  } from "react-router-dom";
import FooterText from "../Footer/Footer";
import Cookies from "js-cookie";
import grey from  "../../img/card_no-icon_grey.svg";

export default function Wallet(props) {

    const [loading, setLoading] = useState(true);
    const [credentials, setCredentials] = useState([]);
    const [activeCredential, setActiveCredential] = useState("");
    const [veririferInfo, setVerifierInfo] = useState({});
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const [share, setShare] = useState(false);

    
    // Check if user is logged in and handle redirection
    let cookie = Cookies.get(config.cookieName);
    if (!cookie) {
       
        window.location.href =
        "/sign-in?redirect_uri=" +
        encodeURIComponent(window.location.origin +
        "/authorize?" +
        encodeURIComponent(searchParams.toString()));
    }

    // Get credentials that match verifier request
    useEffect(() => {
        fetch(config.getCredentialVerifier + window.location.search,{
            method:"GET",
            headers: {
                accept: 'application.json',
                'Content-Type': 'application/json',
            },
        })
        .then(async (response) => {
            // check for error response
            if (!response.ok) {
                const error = await response.text();
                return Promise.reject(error);
            } else {
                let data = await response.json();
                setCredentials(data.credentials);
                setVerifierInfo(data);
                setLoading(false);

                // Auto select if only one is available
                if(data.credentials && data.credentials.length === 1){
                    cardClickHandler(data.credentials[0].name);
                }
            }
        })
        .catch((error) => {
            console.error("Error in API Issue: ", error);
        });
    }, []);


    function cardClickHandler(id) {
        setActiveCredential(id);
    }

    function shareCredential() {
        if(activeCredential !== undefined){
            let url = config.getSelectedShareVerifier + "?credential_id=" + activeCredential + "&state=" + veririferInfo.state;
            console.log(url);
            fetch(url, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                },
            })
            .then((response) => {                
                return response.json();
            })
            .then((data) => {
                console.log(data);
                data = JSON.parse(data);
                if(data.redirect_uri && data.redirect_uri !== "") {                    
                    window.location.href = data.redirect_uri;
                } else {
                    toast.success("Successfuly shared credential.");
                    setShare(true);
                }
            })
            .catch((error) => {
                toast.error("Error " + error);
                console.log(error);
            });
        }else{
            toast.error("Select credential to share with verifier."); 
        }
    }

    return (
        <div className="logged-out page-signin">
            <ToastContainer />
            <section className="content-wrap light-bg">
                <LeftPanel heading="Share credential" />
                <div className="col-content w-60">
            
                    {loading ? (
                        <></>
                    ) : credentials.length === 0 ? (
                        <div className="messages">
                            <h2>Share credential </h2>
                            <div className="container">
                                <p className="light">None of your credentials match the requested credential type.</p>
                            </div>
                        </div>
                    ) : ( share ?
                        <>
                        <div className="messages m-hide">
                            <h2>Share credential </h2>
                        </div>
                        <div className="messages">
                            <p >{veririferInfo.type} credential was shared with <b>verifier {veririferInfo.verifier}</b>. </p>
                        </div>
                        
                        </>:<>
                        <div className="messages m-hide">
                            <h2>Share credential </h2>
                        </div>
                        <div className="messages">
                            <p ><b>Verifier {veririferInfo.verifier}</b> is requesting access to {veririferInfo.type} credential. </p>
                            { credentials.length === 1 ? "" : <p >Select the desired credential and share it with the verifier: </p> }
                        </div>
                        <div className="container">
                            <div className="credentials-container">
                                { credentials.map((credential, index) => (
                                
                                    <div className="explorer-card-wrap" key={index}>
                                        <div
                                            className="explorer-card"
                                            style={{
                                                backgroundImage: `url("${activeCredential == credential.name || activeCredential == "" ? "html/img/card_no-icon_" +credential.bg_color +".svg" : grey}")`, //credential.bg_color 
                                            }}
                                        onClick={() => cardClickHandler(credential.name)}
                                        >
                                        <div className="container">
                                            <p className="item subtitle">{credential.credential_title}</p>
                                            <p className="item title">
                                            {credential.credential_title ===
                                            "MyNextID Email Credential (Self)" ? (
                                                <strong>{props.userEmail}</strong>
                                            ) : (
                                                <strong>
                                                {truncateString(credential.credential_identifier, 40)}
                                                </strong>
                                            )}
                                            </p>
                                            <div className="item">
                                            <p>Issuer: {truncateString(credential.issuer_title, 20)}</p>
                                            {/* <p className="item">Issuer: {credential.issuer_title}</p> */}

                                            {credential.valid_from && (
                                                <p>Valid from: {credential.valid_from.split("T")[0]}</p>
                                            )}
                                            {!credential.valid_from && credential.expires_in &&(
                                                <p>Expires: {credential.expires_in.split("T")[0]}</p>
                                            )}
                                            </div>
                                        </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <button className="btn btn-primary" onClick={() => shareCredential()}>Share credential</button>
                            <p style={{fontSize:"small", textAlign:"justify"}}>By clicking on the button above, you consent to share credential information with verifier {veririferInfo.verifier}.</p>

                            { veririferInfo.issuer && 
                                <div>
                                    <p><b>Verifier is authorized by {veririferInfo.issuer} to request this credential. </b></p>
                                </div>
                            }
                            
                        </div>
                        </>
                    )}
                </div>
                <FooterText style="m-show" />
            </section>
        </div>
    );
}


function truncateString(id, maxLength) {

    if (id.length > maxLength) {
      const start = id.substr(0, maxLength - 3);
      return `${start}...`;
    }
    return id;
}